import Sidebar from "../Sidebar";
import Settings from "./Settings";

function DefaultPocket(props: any) {
    let ele;

    if (props.teleport) {
        ele = <div className='sidebar__controls'>
            <div className="sidebar__controls__header">Press 'x' to teleport!</div>
            <div className="sidebar__controls__content">
                <div className="sidebar__controls__content__col pocket">
                    <div id="ex" className='icons'></div>
                </div>
            </div>
        </div>
    } else {
        ele = <div className='sidebar__controls'>
            <div className="sidebar__controls__header">C O N T R O L S</div>
            <div className="sidebar__controls__content">
                <div className="sidebar__controls__content__col">
                    <div className="sidebar__controls__content__col__row">
                        <div id="left" className='icons'></div>
                        <div id="right" className='icons'></div>
                    </div>
                    <div className="sidebar__controls__content__col__row">
                        <div id="up" className='icons'></div>
                        <div id="jump" className='icons'></div>
                    </div>
                </div>
                <div className="sidebar__controls__content__col">
                    <div className="text">
                        move
                    </div>
                    <div className="text">
                        jump
                    </div>
                </div>
            </div>
        </div>
    }

    return (
        <>
            <Sidebar hasSettings={true}>
                <Settings />
                <div className="sidebar__header">Hi!</div>
                <div className="sidebar__content">
                    <span id='im'>I'm John.</span>
                    <span id='gettoknow'>Get to know me by making your way to the stars</span>
                    <span id='note'>On a time crunch?</span>
                    <span id='noteSec'>Use the hamburger menu on the top right to find you way!</span>
                </div>
                {ele}
            </Sidebar>
        </>
    )
}

export default DefaultPocket